import { createContext, type ReactNode, useMemo } from 'react';

import { useIsCompanySite, useRequiredContext } from 'hooks';

interface PriceContextType {
	usePriceExcVat: boolean;
}

export const PriceContext = createContext<PriceContextType | undefined>(
	undefined,
);

interface Props {
	children: ReactNode;
}

export function PriceContextProvider({ children }: Props) {
	const usePriceExcVat = useIsCompanySite();
	const value = useMemo(() => ({ usePriceExcVat }), [usePriceExcVat]);

	return <PriceContext value={value}>{children}</PriceContext>;
}
PriceContextProvider.displayName = 'PriceContextProvider';

export function usePriceContext() {
	return useRequiredContext(PriceContext, 'PriceContext');
}
